import { computed } from 'vue-demi';
import { RANK, INCREASE_TYPE } from '../common/enum';
const { useCommonApi } = require('@fegobull/webapi').use;
const request = useCommonApi('quote-rank-v2');

// 因为站外的场景获取不到客户端版本号，但是通用榜单协议需要该字段进行判断。
// 为了兼容站外场景，这里约定一个版本号，站外场景传递该版本号。
const CLIENT_VERSION = 19707;

export default (props) => {
    const isRankByCard = computed(() => props.rankType === RANK.CARD);

    const getRankByCard = async () => {
        const data = {
            cardId: props.cardId,
            increase_type: props.increaseType || INCREASE_TYPE.CLOSE,
            lang: props.language,
            count: props.count,
            platform: props.platform,
            clientVersion: CLIENT_VERSION
        };
        try {
            return await request.get('get-rank-list-by-card', data);
        } catch (err) {
            console.error('rank-list-by-card', err);
        }
    };

    return {
        isRankByCard,
        getRankByCard
    };
};
